import { createErrorMessageTypeGuard } from '../createErrorMessageTypeGuard';
import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type TeamSummaryDetail = {
   members: TeamSummaryDetailMember[];
   courses: TeamSummaryDetailCourse[];
};

export type TeamSummaryDetailMember = {
   userid: number;
   name: string;
   image: string;
   completions: { [key: number]: number };
   assignedCoursesUrl: string;
};

export type TeamSummaryDetailCourse = {
   course_assignmentid: number;
   completions: number;
   completionPercent: number;
   total: number;
   title: string;
   stageCount: number;
   wikiid: number;
};

export async function getCourseAssignmentTeamSummaryDetails(
   teamid: number,
   common: CommonRequestOptions = {}
): Promise<TeamSummaryDetail> {
   return makeRequest('get', `course_assignments/teamSummaries/${teamid}`, common);
}

type GetCourseAssignmentTeamSummaryDetailErrorCode =
   'course_assignments.get_team_summary_details_.team_not_found';

getCourseAssignmentTeamSummaryDetails.errorMessages =
   createErrorMessageTypeGuard<GetCourseAssignmentTeamSummaryDetailErrorCode>();
